import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { t } = useLanguage();

  useEffect(() => {
    if (!loading && user?.is_admin) {
      navigate('/admin', { replace: true });
    }
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[#F9F6F0] px-4">
      <div className="max-w-md w-full bg-white p-12 rounded-lg border border-[#2C5263]/10 shadow-sm">
        <div className="text-center mb-8">
          <ShieldCheck size={48} className="text-[#2C5263] mx-auto mb-4" />
          <h1 className="text-3xl font-serif text-[#1A1A1A] mb-2">
            {t('admin.loginTitle')}
          </h1>
          <p className="text-[#666666] text-sm">
            {t('admin.loginSubtitle')}
          </p>
        </div>

        <button
          data-testid="google-login-button"
          onClick={handleLogin}
          className="w-full bg-[#2C5263] text-white px-6 py-4 rounded-md text-base font-medium hover:bg-[#1A3644] transition-colors flex items-center justify-center gap-3"
        >
          <LogIn size={20} />
          {t('admin.login')}
        </button>

        {!loading && user && !user.is_admin && (
          <p className="mt-6 text-sm text-red-600 text-center">
            Il tuo account non ha permessi di amministrazione.
          </p>
        )}
      </div>
    </div>
  );
};

export default AdminLoginPage;
